import { tv } from 'tailwind-variants'

export const messageBoxStyles = tv({
  slots: {
    wrapper: 'pt-3',
    avatar: '',
    container: 'max-w-full',
    labelWrapper: '',
    labelHeader: 'w-full mb-1',
    content: 'break-words min-w-4 max-w-[50vw] xs:max-w-[60vw] md:max-w-sm p-2',
    imageWrapper: 'flex-none w-8 h-8 rounded-full',
    attachmentDownloadIcon: '',
    text: 'whitespace-pre-wrap text-gray-900',
    headerText: 'text-gray-700',
    attachmentInfo: 'flex-1 text-left',
    attachmentDownloadWrapper: 'w-8 h-8 cursor-pointer'
  },
  variants: {
    type: {
      user: {
        wrapper: 'ml-32 justify-end',
        container: 'items-end',
        labelWrapper: 'items-end',
        content: 'bg-gray-100 rounded-b-lg rounded-tl-lg',
        imageWrapper: 'bg-gray-200 text-gray-700',
        attachmentDownloadIcon: 'text-gray-700'
      },
      seller: {
        wrapper: 'mr-16',
        avatar: 'text-blue-500',
        container: 'items-start',
        labelWrapper: 'items-start',
        content: 'bg-blue-200 ml-7 rounded-b-lg rounded-tr-lg',
        imageWrapper: 'bg-blue-400 text-blue-100',
        attachmentDownloadIcon: 'text-blue-500'
      },
      bot: {
        wrapper: 'mr-16',
        avatar: 'text-green-500',
        container: 'items-start',
        labelWrapper: 'items-start',
        content: 'bg-green-200 ml-7 rounded-b-lg rounded-tr-lg'
      }
    }
  },
  defaultVariants: {
    type: 'bot'
  }
})
